var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnaliseDados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.37,241.26l-51.89-64a37.58,37.58,0,1,0-63.23,0L91.07,267.5a30.9,30.9,0,0,0-9-1.46,31.32,31.32,0,1,0,31.31,31.31,30.91,30.91,0,0,0-4-14.92l73.2-90.23a36,36,0,0,0,26.38,0l51.92,64A63.85,63.85,0,0,1,279.37,241.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M309.61,257A40.34,40.34,0,1,0,350,297.36,40.39,40.39,0,0,0,309.61,257Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M423.36,86.56a70.64,70.64,0,0,0-70.56,70.57,69.93,69.93,0,0,0,17.75,46.3l-30.69,37.83a64,64,0,0,1,18.4,14.94L389,218.35a69.69,69.69,0,0,0,34.4,9.34,70.57,70.57,0,1,0,0-141.13Zm0,117.43a46.86,46.86,0,1,1,46.87-46.86A46.91,46.91,0,0,1,423.36,204Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M462.56,401.73H29.92a11.86,11.86,0,0,0,0,23.71H462.56a11.86,11.86,0,0,0,0-23.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M462.59,285.51H400.73a11.85,11.85,0,0,0,0,23.7h61.86a11.85,11.85,0,1,0,0-23.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M423.36,348.35a11.86,11.86,0,0,0,0-23.71H400.73a11.86,11.86,0,0,0,0,23.71Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M265,139.47h61.85a11.85,11.85,0,1,0,0-23.7H265a11.85,11.85,0,1,0,0,23.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M265,178.61h22.64a11.85,11.85,0,0,0,0-23.7H265a11.85,11.85,0,1,0,0,23.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaliseDados);
export default __webpack_public_path__ + "static/media/analise-dados.a3ae91a1f96270194eb5f2670ab0f373.svg";
export { ForwardRef as ReactComponent };